module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAMCAYAAAC9QufkAAAAAXNSR0IArs4c6QAAASJJREFUKFOV0a9L3XEUxvHX4YpBsBiMprGyZDEJgkkQhZUxy5KrNsP8XkH03omIyejAJGxlDHVRMGgybDDwDxANBtsUUS5H7hXx11fwPvXzPM/5nPcJ7Wopu10bV42NaCubGb76JY0LM+2FF7ImFDhTMfD6cD0/SN/REEYUsXMbrueoTrum47x0jcXs17CHLmFKEatNX1jIEWEL/zCmGiePCpaz16UDoU/4pojPd+9hMd9o+I23wnGroIi/LcNcduqwg0FpX8Owubi6D9+aelT8FIbwX5owG9tquYZJ4QgDijh9+Kt7YM0pFWvCpxYUNvEeFyoGfYk/T3k8p13LKuZbPEhMqMaPMpDlp6rnR2ldWFFEs6xUL995Pt+ZdSiiOb1UN68VUrJM+VaRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/dui.png
// module id = c/aw
// module chunks = 0